import { render, staticRenderFns } from "./MoreSubmenu.vue?vue&type=template&id=9afdb6e8&"
import script from "./MoreSubmenu.vue?vue&type=script&lang=js&"
export * from "./MoreSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports